import PropTypes from 'prop-types';
import React from 'react';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import Report from '../../../common/components/Report';

const ReceptaclePodPerformanceReport = props => (
  <Report
    id={props.id}
    tabs={[
      {
        value: ReportDefinitions.RECEPTACLE_POD_PERFORMANCE_404_SUMMARY.id,
        label: 'Summary',
      },
      {
        value: ReportDefinitions.RECEPTACLE_POD_PERFORMANCE_404_DETAILS.id,
        label: 'Details',
        loadFromTable: true,
        loadFromTableMessage: 'app.warning.load.from.summary.report',
      },
    ]}
    {...props}
  />
);
export default ReceptaclePodPerformanceReport;

ReceptaclePodPerformanceReport.propTypes = {
  id: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  generatedOnDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  reportId: PropTypes.string,
};
